import axiosInstance from "../../Lib/axios";
import {PaymentWrapper} from "../Accounting/PaymentWrapper";
import {
  GET_CUSTOMER_SUCCESSFULLY,
  GET_CUSTOMER_FAILED,
  GET_CUSTOMER_LIST_SUCCESSFULLY,
  GET_CUSTOMER_LIST_FAILED,
  GET_LEAD_LIST_SUCCESSFULLY,
  GET_LEAD_LIST_FAILED,
  ADD_LEAD_SUCCESSFULLY,
  ADD_LEAD_FAILED,
  GET_ACCOUNT_INFO_SUCCESSFULLY,
  GET_ACCOUNT_INFO_FAILED,
  GET_SERVICE_ORDER_LIST,
  GET_SERVICE_ORDER_LIST_FAILED,
  GET_NOTIFICATION_SUCCESSFULLY,
  GET_NOTIFICATION_FAILED,
  UPDATE_NOTIFICATION_SUCCESSFULLY,
  UPDATE_NOTIFICATION_FAILED,
  ADD_NEW_CARD,
  ADD_NEW_CARD_FAILED,
  UPDATE_CARD,
  UPDATE_CARD_FAILED,
  DELETE_CARD,
  DELETE_CARD_FAILED,
  BLOCK_LIST,
  BLOCK_LIST_FAILED,
  ADD_ACCOUNT_NOTES,
  ADD_ACCOUNT_NOTES_FAILED,
  GET_ACCOUNT_NOTES,
  GET_ACCOUNT_NOTES_FAILED,
  GET_CARD_LIST,
  GET_CARD_LIST_FAILED,
  GET_AUTHORIZED_USER,
  GET_AUTHORIZED_USER_FAILED,
  ADD_AUTHORIZED_USER,
  ADD_AUTHORIZED_USER_FAILED,
  DELETE_AUTHORIZED_USER,
  DELETE_AUTHORIZED_USER_FAILED,
  GET_CALL_LOG,
  GET_CALL_LOG_FAILED,
  ADD_CALL_LOG,
  ADD_CALL_LOG_FAILED,
  GET_PRICING_HISTORY,
  GET_PRICING_HISTORY_FAILED,
  VIEW_SERVICE,
  VIEW_SERVICE_FAILED,
  GET_PAUSE_SERVICE,
  GET_PAUSE_SERVICE_FAILED,
  PAUSE_SERVICE,
  UPDATE_PAUSE_SERVICE,
  UPDATE_PAUSE_SERVICE_FAILED,
  PAUSE_SERVICE_FAILED,
  GET_DOG_LIST,
  GET_DOG_LIST_FAILED,
  DELETE_PAUSE_SERVICE,
  DELETE_PAUSE_SERVICE_FAILED,
  EDIT_SERVICE,
  EDIT_SERVICE_FAILED,
  GET_PAUSE_REASON,
  GET_PAUSE_REASON_FAILED,
  ADD_DOG,
  ADD_DOG_FAILED,
  UPDATE_DOG,
  UPDATE_DOG_FAILED,
  DELETE_DOG,
  DELETE_DOG_FAILED,
  SEND_REMINDER,
  SEND_REMINDER_FAILED,
  GET_LEAD_SUCCESSFULLY,
  GET_LEAD_FAILED,
  GET_SERVICE_ORDER_ENQUIRY,
  GET_SERVICE_ORDER_ENQUIRY_FAILED,
  UPDATE_LEAD_SUCCESSFULLY,
  UPDATE_LEAD_FAILED,
  FIELD_OFFICE,
  FIELD_OFFICE_FAILED,
  CHECK_ZIPCODE_SUCCESSFULLY,
  CHECK_ZIPCODE_FAILED,
  GET_PRICING_SUCCESSFULLY,
  GET_PRICING_FAILED,
  ADD_SRVICE_ORDER_ENQUIRY,
  ADD_SRVICE_ORDER_ENQUIRY_FAILED,
  UPDATE_SERVICE_ORDER_ENQUIRY,
  UPDATE_SERVICE_ORDER_ENQUIRY_FAILED,
  VIEW_SERVICE_ORDER,
  VIEW_SERVICE_ORDER_FAILED,
  ADD_SERVICE_ORDER,
  ADD_SERVICE_ORDER_FAILED,
  UPDATE_SERVICE_ORDER,
  UPDATE_SERVICE_ORDER_FAILED,
  GET_INVOICE_LIST,
  GET_INVOICE_LIST_FAILED,
  GET_FINALIZE_INVOICE,
  GET_FINALIZE_INVOICE_FAILED,
  GET_INVOICE_DETAIL,
  GET_INVOICE_DETAIL_FAILED,
  SERVICE_ORDER_NUMBER_LIST,
  SERVICE_ORDER_NUMBER_LIST_FAILED,
  GET_INVOICE_SUMMARY,
  GET_INVOICE_SUMMARY_FAILED,
  SEND_INVOICE,
  SEND_INVOICE_FAILED,
  PRINT_INVOICE,
  PRINT_INVOICE_FAILED,
  ADD_INVOICE,
  ADD_INVOICE_FAILED,
  EDIT_INVOICE,
  EDIT_INVOICE_FAILED,
  DELETE_INVOICE,
  DELETE_INVOICE_FAILED,
  EDIT_INVOICE_LINE_ITEM,
  EDIT_INVOICE_LINE_ITEM_FAILED,
  DELETE_INVOICE_LINE_ITEM,
  DELETE_INVOICE_LINE_ITEM_FAILED,
  ADD_LOG_PAYMENT_SUCCESSFULLY,
  ADD_LOG_PAYMENT_FAILED,
  ADD_MANUAL_LOG_PAYMENT_SUCCESSFULLY,
  ADD_MANUAL_LOG_PAYMENT_FAILED,
  DELETE_LOG_PAYMENT_SUCCESSFULLY,
  DELETE_LOG_PAYMENT_FAILED,
  ADD_INVOICE_LINE_ITEM,
  ADD_INVOICE_LINE_ITEM_FAILED,
  ADD_BLOCK_USER,
  ADD_BLOCK_USER_FAILED,
  DELETE_BLOCK_USER,
  DELETE_BLOCK_USER_FAILED,
  FIELD_OFFICE_DETAIL_SUCCESSFULLY,
  FIELD_OFFICE_DETAIL_FAILED,
  GET_STAFF_LIST_SUCCESSFULLY,
  GET_STAFF_LIST_FAILED,
  ADD_NON_SERVICEABLE_ENQUIRY,
  ADD_NON_SERVICEABLE_ENQUIRY_FAILED,
  ADD_CUSTOMER_SUCCESSFULLY,
  ADD_CUSTOMER_FAILED,
  GET_TECHNICIAN_LIST,
  GET_TECHNICIAN_LIST_FAILED, 
  DELETE_PHONE_NUMBER, 
  DELETE_PHONE_NUMBER_FAILED,
  GET_SERVICE_HISTORY,
  GET_SERVICE_HISTORY_FAILED,
  REFUND_PAYMENT,
  REFUND_PAYMENT_FAILED,
  GET_SALES_TAX,
  GET_SALES_TAX_FAILED, 
  SUSPEND_ACCOUNT, 
  SUSPEND_ACCOUNT_FAILED,
  GET_SERVICE_ORDER_FILTER,
  GET_SERVICE_ORDER_FILTER_FAILED,
  GET_WORK_ORDER_FILTER,
  GET_WORK_ORDER_FILTER_FAILED,
  GET_FIELD_TECHNICIAN_FILTER,
  GET_FIELD_TECHNICIAN_FILTER_FAILED,
  GET_WORK_ORDER_LIST,
  GET_WORK_ORDER_LIST_FAILED,
  DEACTIVATE_SERVICE_ORDER,
  DEACTIVATE_SERVICE_ORDER_FAILED,
  GET_REPRESENTATIVES_LIST,
  GET_REPRESENTATIVES_LIST_FAILED,
  VALIDATE_COUPON_SUCCESSFULLY,
  VALIDATE_COUPON_FAILED,
  UPDATE_CALL_LOG,
  UPDATE_CALL_LOG_FAILED,
  VOID_INVOICE_SUCCESSFULLY,
  VOID_INVOICE_FAILED,
  GET_PAYMENT_HISTORY_SUCCESSFULLY,
  GET_PAYMENT_HISTORY_FAILED,
  POST_PAYMENT_HISTORY_SUCCESSFULLY,
  POST_PAYMENT_HISTORY_FAILED,
  DELETE_PAYMENT_HISTORY_SUCCESSFULLY,
  DELETE_PAYMENT_HISTORY_FAILED,
  GET_PAYMENT_HISTORY_NEW_SUCCESSFULLY,
  GET_PAYMENT_HISTORY_NEW_FAILED,
  ADD_MANUAL_INVOICE,
  ADD_MANUAL_INVOICE_FAILED,
  GET_WORK_ORDER_DETAIL,
  GET_WORK_ORDER_DETAIL_FAILED,
  ADD_CREDIT_MEMO,
  ADD_CREDIT_MEMO_FAILED,
  ADD_CREDIT_MEMO_LINE_ITEM,
  ADD_CREDIT_MEMO_LINE_ITEM_FAILED,
  GET_CREDIT_MEMO_DETAIL,
  GET_CREDIT_MEMO_DETAIL_FAILED,
  GET_INVOICE_CREDIT_MEMO_LIST,
  GET_INVOICE_CREDIT_MEMO_LIST_FAILED,
  LAST_THREE_CREDIT_MEMO,
  LAST_THREE_CREDIT_MEMO_FAILED,
  ADD_UNATTACHED_PAYMENT_FAILED,
  ADD_UNATTACHED_PAYMENT_SUCCESSFULLY,
  CLEAN_PAYMENT_RESPONSE,
  REFUND_REMAINING_BALANCE_SUCCESS,
  REFUND_REMAINING_BALANCE_FAILED,
  ADD_STAX_PAYMENT_INFO,
  ADD_STAX_PAYMENT_INFO_FAILED
} from "../types";

// Get all customers
export const getCustomers = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`crm/customer-user/`, { params })
      .then((response) => {
        dispatch({
          type: GET_CUSTOMER_LIST_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_CUSTOMER_LIST_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// Get customer detail
export const getCustomerDetail = (id) => {
  return (dispatch) => {
    return axiosInstance
      .get(`crm/customer-user/${id}/`)
      .then((response) => {
        dispatch({
          type: GET_CUSTOMER_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_CUSTOMER_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// Get customer detail
export const clearCustomerDetail = () => {
  return (dispatch) => {
    dispatch({
      type: GET_CUSTOMER_SUCCESSFULLY,
      data: {}
    });
  }
}

// Update customer detail
export const updateCustomer = (id, params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`crm/customer-user/${id}/`, params)
      .then((response) => {
        dispatch({
          type: GET_CUSTOMER_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_CUSTOMER_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// add customer detail
export const addCustomer = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`crm/customer-user/`, params)
      .then((response) => {
        dispatch({
          type: ADD_CUSTOMER_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: ADD_CUSTOMER_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// Get all leads
export const getLeads = (params) => {
  return async (dispatch) => {
    return await axiosInstance
      .get(`crm/lead-user`, { params })
      .then((response) => {
        dispatch({
          type: GET_LEAD_LIST_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_LEAD_LIST_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// Get a lead
export const getLeadById = (id) => {
  return (dispatch) => {
    return axiosInstance
      .get(`crm/lead-user/${id}`)
      .then((response) => {
        dispatch({
          type: GET_LEAD_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_LEAD_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// add lead
export const addLeads = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`crm/lead-user/`, params)
      .then((response) => {
        dispatch({
          type: ADD_LEAD_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: ADD_LEAD_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// add lead
export const updateLeads = (params, onSuccess = () => {}) => {
  return (dispatch) => {
    const uuid = params.uuid;
    delete params.uuid;
    return axiosInstance
      .patch(`crm/lead-user/${uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_LEAD_SUCCESSFULLY,
          data: response?.data,
        });
        typeof onSuccess === 'function' && onSuccess();
        return Promise.resolve(response.data)
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: UPDATE_LEAD_FAILED,
            data: error?.response?.data,
          });
          return Promise.reject(error?.response?.data)
        }
      });
  };
};

// Get service order enquiry by user id
export const getServiceOrderEnquiry = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/service-order-enquiry/`, { params })
      .then((response) => {
        dispatch({
          type: GET_SERVICE_ORDER_ENQUIRY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_SERVICE_ORDER_ENQUIRY_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

//Get customer user account info
export const getAccountInfo = (id) => {
  return (dispatch) => {
    return axiosInstance
      .get(`user/${id}/`)
      .then((response) => {
        dispatch({
          type: GET_ACCOUNT_INFO_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_ACCOUNT_INFO_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Service order
export const getServiceOrder = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/service-order/`, { params })
      .then((response) => {
        dispatch({
          type: GET_SERVICE_ORDER_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_ORDER_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Service order by id
export const getServiceOrderById = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/service-order/${uuid}`)
      .then((response) => {
        dispatch({
          type: VIEW_SERVICE_ORDER,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: VIEW_SERVICE_ORDER_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// add Service order
export const addServiceOrder = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/service-order/`, params)
      .then((response) => {
        dispatch({
          type: ADD_SERVICE_ORDER,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_SERVICE_ORDER_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// add Service order
export const updateServiceOrder = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/service-order/${params.uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_SERVICE_ORDER,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_SERVICE_ORDER_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// partial update Service order
export const updatePartialServiceOrder = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/partial-service-order/${params.uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_SERVICE_ORDER,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_SERVICE_ORDER_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// update notifications
export const updateNotificationById = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/notification-preference/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_NOTIFICATION_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_NOTIFICATION_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// update notifications
export const getNotificationById = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/notification-preference/`, { params })
      .then((response) => {
        dispatch({
          type: GET_NOTIFICATION_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_NOTIFICATION_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Add new Card
export const addNewCard = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/user-billing-info/`, params)
      .then((response) => {
        dispatch({
          type: ADD_NEW_CARD,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_NEW_CARD_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//get card list
export const getCardList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/user-billing-info/`, { params })
      .then((response) => {
        dispatch({
          type: GET_CARD_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_CARD_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Update Card
export const updateCard = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/user-billing-info/${params.uuid}/`, { ...params })
      .then((response) => {
        dispatch({
          type: UPDATE_CARD,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_CARD_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// delete Card
export const deleteCard = (params) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`/user-billing-info/${params.uuid}/`)
      .then(() => {
        dispatch({
          type: DELETE_CARD,
          data: {uuid: params?.uuid},
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_CARD_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get block list
export const getBlockList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/block-list/`, { params })
      .then((response) => {
        dispatch({
          type: BLOCK_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: BLOCK_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// add block user
export const addBlockUser = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/crm/block-list/`, params)
      .then((response) => {
        dispatch({
          type: ADD_BLOCK_USER,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_BLOCK_USER_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// add block user
export const deleteBlockUser = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`/crm/block-list/${uuid}/`)
      .then((response) => {
        dispatch({
          type: DELETE_BLOCK_USER,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_BLOCK_USER_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// add account notes
export const addAccountNotes = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/crm/account-notes/`, params)
      .then((response) => {
        dispatch({
          type: ADD_ACCOUNT_NOTES,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_ACCOUNT_NOTES_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get account notes
export const getAccountNotes = (params) => {
  // console.log("params Check::::>",params)
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/account-notes/`, { params })
      .then((response) => {
        dispatch({
          type: GET_ACCOUNT_NOTES,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_ACCOUNT_NOTES_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get authorized user list
export const getAuthorizedUserList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/authorized-user/`, { params })
      .then((response) => {
        dispatch({
          type: GET_AUTHORIZED_USER,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_AUTHORIZED_USER_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// add authorized user
export const addAuthorizedUser = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/crm/authorized-user/`, params)
      .then((response) => {
        dispatch({
          type: ADD_AUTHORIZED_USER,
          data: response.data,
        });
        return true;
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_AUTHORIZED_USER_FAILED,
              data: error.response.data,
            });
            return false;
          }
        }
      });
  };
};

// delete authorized user
export const deleteAuthorizedUser = (id) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`/crm/authorized-user/${id}/`)
      .then((response) => {
        dispatch({
          type: DELETE_AUTHORIZED_USER,
          data: response.data,
        });
        return true;
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_AUTHORIZED_USER_FAILED,
              data: error.response.data,
            });
            return false;
          }
        }
      });
  };
};

// get call log list
export const getCallLogList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/call-log/`, { params })
      .then((response) => {
        dispatch({
          type: GET_CALL_LOG,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_CALL_LOG_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// add authorized user
export const addCallLog = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/crm/call-log/`, params)
      .then((response) => {
        dispatch({
          type: ADD_CALL_LOG,
          data: response.data,
        });
        return Promise.resolve(response.data)
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_CALL_LOG_FAILED,
              data: error.response.data,
            });
            return Promise.reject(error.response.data)
          }
        }
      });
  };
};

// get pricing history
export const getPricingHistory = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/pricing-history/`, { params })
      .then((response) => {
        dispatch({
          type: GET_PRICING_HISTORY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_PRICING_HISTORY_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//////////// service tab

//View service
export const viewService = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/service/`, { params })
      .then((response) => {
        dispatch({
          type: VIEW_SERVICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: VIEW_SERVICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Pause service
export const getPauseService = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/service-pause/`, { params })
      .then((response) => {
        dispatch({
          type: GET_PAUSE_SERVICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_PAUSE_SERVICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Pause service
export const pauseService = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/service-pause/`, params)
      .then((response) => {
        dispatch({
          type: PAUSE_SERVICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: PAUSE_SERVICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

export const updatePauseService = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/service-pause/${uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_PAUSE_SERVICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_PAUSE_SERVICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Delete Pause service
export const deletePauseService = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`/service-pause/${uuid}/`, {})
      .then(() => {
        dispatch({
          type: DELETE_PAUSE_SERVICE,
          data: { message: "deleted" },
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_PAUSE_SERVICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//edit service
export const editService = (uuid, params) => {

  if( !uuid ) {
    return (dispatch) => dispatch({ type: "CLEAR_EDIT_SERVICE" })
  }

  return (dispatch) => {
    return axiosInstance
      .patch(`/service-order/${uuid}/`, params)
      .then((response) => {
        dispatch({
          type: EDIT_SERVICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: EDIT_SERVICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Pause service reasons
export const getPauseReason = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/service-pause-reason/`, { params })
      .then((response) => {
        dispatch({
          type: GET_PAUSE_REASON,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_PAUSE_REASON_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get Dog List
export const getPets = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`pet/`, { params })
      .then((response) => {
        dispatch({
          type: GET_DOG_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_DOG_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Add pet
export const addPet = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`pet/`, params)
      .then((response) => {
        dispatch({
          type: ADD_DOG,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_DOG_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// update pet
export const updatePet = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`pet/${params.uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_DOG,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_DOG_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Delete pet
export const deletePet = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`pet/${uuid}/`, {})
      .then(() => {
        dispatch({
          type: DELETE_DOG,
          data: { message: "deleted" },
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_DOG_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// send email reminder
export const sendEmailReminder = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`cc-reminder-log/`, params)
      .then((response) => {
        dispatch({
          type: SEND_REMINDER,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: SEND_REMINDER_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get franchise by Id
export const getFranchiseById = (id) => {
  return (dispatch) => {
    return axiosInstance
      .get(`field-office/${id}/`)
      .then((response) => {
        dispatch({
          type: FIELD_OFFICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: FIELD_OFFICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Check zip code is valid or not
export const checkZipCode = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`field-office`, {
        params,
      })
      .then((response) => {
        dispatch({
          type: CHECK_ZIPCODE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          // if (error.response.status === 401 || error.response.status === 403) {}
          dispatch({
            type: CHECK_ZIPCODE_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// get field office by id
export const getFieldOfficeById = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`field-office/initial_cleanning_days`, { params })
      .then((response) => {
        dispatch({
          type: FIELD_OFFICE_DETAIL_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          // if (error.response.status === 401 || error.response.status === 403) {}
          dispatch({
            type: FIELD_OFFICE_DETAIL_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// Check zip code is valid or not
export const resetCheckZipcode = () => {
  return (dispatch) => {
    dispatch({
      type: CHECK_ZIPCODE_SUCCESSFULLY,
      data: {},
    });
  };
};

// reset price calc
export const resetPricingCalculator = () => {
  return (dispatch) => {
    dispatch({
      type: GET_PRICING_SUCCESSFULLY,
      data: {},
    });
  };
};

// pricing calculator
export const pricingCalculator = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`pricing-calculator`, params, {})
      .then((response) => {
        dispatch({ type: GET_PRICING_SUCCESSFULLY, data: response.data });
      })
      .catch((error) => {
        if (error.response) {
          // if (
          //     error.response.status === 401 ||
          //     error.response.status === 403
          // ) {}
          dispatch({
            type: GET_PRICING_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// add service order enquiry
export const addServiceOrderEnquiry = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`service-order-enquiry/`, params)
      .then((response) => {
        dispatch({
          type: ADD_SRVICE_ORDER_ENQUIRY,
          data: response.data,
        });
        return Promise.resolve(response.data)
      })
      .catch((error) => {
        if (error.response) {
          // if (error.response.status === 401 || error.response.status === 403) {}
          dispatch({
            type: ADD_SRVICE_ORDER_ENQUIRY_FAILED,
            data: error.response.data,
          });
          return Promise.reject(error.response.data)
        }
      });
  };
};

// update service order enquiry
export const updateServiceOrderEnquiry = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`service-order-enquiry/${params.uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_SERVICE_ORDER_ENQUIRY,
          data: response.data,
        });
        return Promise.resolve(response.data)
      })
      .catch((error) => {
        if (error.response) {
          // if (error.response.status === 401 || error.response.status === 403) {}
          dispatch({
            type: UPDATE_SERVICE_ORDER_ENQUIRY_FAILED,
            data: error.response.data,
          });
          return Promise.reject(error.response.data)
        }
      });
  };
};

//Export data in csv
export const getCSVData = (params) => {
  return () => {
    return axiosInstance
      .get(`/message/`, { params })
      .then((response) => {
        let data = response.data;
        var blob = new Blob([data], { type: "application/CSV" });

        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "messages.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
        }
      });
  };
};

// get invoice Credit Memo list
export const getInvoiceCreditMemoList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/credit-memo/get_credit_memo_and_invoice/`, {
        params,
      })
      .then((response) => {
        dispatch({
          type: GET_INVOICE_CREDIT_MEMO_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: GET_INVOICE_CREDIT_MEMO_LIST_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// get invoice list
export const getInvoiceList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/`, {
        params,
      })
      .then((response) => {
        dispatch({
          type: GET_INVOICE_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: GET_INVOICE_LIST_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// get invoice list
export const finalizeInvoice = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/${uuid}/finalize-invoice/`)
      .then((response) => {
        dispatch({
          type: GET_FINALIZE_INVOICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: GET_FINALIZE_INVOICE_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// get invoice by id
export const getInvoiceById = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/${uuid}/`)
      .then((response) => {
        dispatch({
          type: GET_INVOICE_DETAIL,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: GET_INVOICE_DETAIL_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// add Mannual Invoice - new
// export const addManualInvoice = (params) => {
//   return (dispatch) => {
//     return axiosInstance
//       .post(`/invoice/manual_invoice/`, params)
//       .then((response) => {
//         dispatch({
//           type: ADD_MANUAL_INVOICE,
//           data: response.data,
//         });
//       })
//       .catch((error) => {
//         if (error.response) {
//           if (error.response.status === 401 || error.response.status === 403) {
//             window.location.assign("/");
//             localStorage.clear();
//             sessionStorage.clear();
//           }
//           dispatch({
//             type: ADD_MANUAL_INVOICE_FAILED,
//             data: error.response.data,
//           });
//         }
//       });
//   };
// };

// add invoice
export const addInvoice = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/invoice/`, params)
      .then((response) => {
        dispatch({
          type: ADD_INVOICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: ADD_INVOICE_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// update invoice
export const editInvoice = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/invoice/${uuid}/`, params)
      .then((response) => {
        dispatch({
          type: EDIT_INVOICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: EDIT_INVOICE_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// delete Manualy
export const deleteInvoice = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/invoice/bulk_delete/`, params,{})
      .then((response) => {
        dispatch({
          type: DELETE_INVOICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_INVOICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// add invoice
// export const deleteInvoice = (uuid) => {
//   return (dispatch) => {
//     return axiosInstance
//       .delete(`/invoice/${uuid}/`)
//       .then(() => {
//         dispatch({
//           type: DELETE_INVOICE,
//           data: { uuid },
//         });
//       })
//       .catch((error) => {
//         if (error.response) {
//           if (error.response.status === 401 || error.response.status === 403) {
//             window.location.assign("/");
//             localStorage.clear();
//             sessionStorage.clear();
//           }
//           dispatch({
//             type: DELETE_INVOICE_FAILED,
//             data: error.response.data,
//           });
//         }
//       });
//   };
// };

// get invoice summary
export const getInvoiceSummary = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/get_overdue_open_last_invoices/`, { params })
      .then((response) => {
        dispatch({
          type: GET_INVOICE_SUMMARY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: GET_INVOICE_SUMMARY_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// resend invoice
export const resendInvoice = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/${uuid}/resend_invoice/`)
      .then((response) => {
        dispatch({
          type: SEND_INVOICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: SEND_INVOICE_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// resend invoice
export const printInvoices = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/invoice/print-invoices/`, params)
      .then((response) => {
        let byteCharacters = atob(response.data.data);
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: "application/pdf;base64" });
        let fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        dispatch({
          type: PRINT_INVOICE,
          data: fileURL,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: PRINT_INVOICE_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// Create Unattached-Payment
export const addUnattachedPayment = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/unattached-payment/create_unattachedpayment/`, params, {})
      .then((response) => {
        dispatch({
          type: ADD_UNATTACHED_PAYMENT_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_UNATTACHED_PAYMENT_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};


// Get Manual Payment
// Payment
export const addPaymentLog = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/crm/manual-payment/`, params, {})
      .then((response) => {
        dispatch({
          type: ADD_LOG_PAYMENT_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_LOG_PAYMENT_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Add Manual Payment without invoice
export const addManualPaymentLog = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/crm/account-manual-payment/`, params, {})
      .then((response) => {
        dispatch({
          type: ADD_MANUAL_LOG_PAYMENT_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_MANUAL_LOG_PAYMENT_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Payment History
// Get all payments

// export const getPaymentHistory = (params) => {
//   return (dispatch) => {
//     return axiosInstance
//       .get(`/crm/payment-history`, { params })
//       .then((response) => {
//         dispatch({
//           type: GET_PAYMENT_HISTORY_SUCCESSFULLY,
//           data: PaymentWrapper(response.data),
//         });
//       })
//       .catch((error) => {
//         if (error && error.response) {
//           if (error.response.status === 401 || error.response.status === 403) {
//             window.location.assign("/");
//             localStorage.clear();
//             sessionStorage.clear();
//           }
//           if (error.response) {
//             dispatch({
//               type: GET_PAYMENT_HISTORY_FAILED,
//               data: error.response.data,
//             });
//           }
//         }
//       });
//   };
// };

// export const getPaymentHistoryNew = (params) => {
//   return (dispatch) => {
//     dispatch({
//       type: GET_PAYMENT_HISTORY_NEW_SUCCESSFULLY,
//       // data : testData,          
//     });
//     return axiosInstance
//       .get(`/crm/payment-history`, { params })
//       .then((response) => {
//         dispatch({
//           type: GET_PAYMENT_HISTORY_NEW_SUCCESSFULLY,
//           data: response.data,
//           // data : testData,          
//         });
//       })
//       .catch((error) => {
//         if (error && error.response) {
//           if (error.response.status === 401 || error.response.status === 403) {
//             window.location.assign("/");
//             localStorage.clear();
//             sessionStorage.clear();
//           }
//           if (error.response) {
//             dispatch({
//               type: GET_PAYMENT_HISTORY_NEW_FAILED,
//               data: error.response.data,
//             });
//           }
//         }
//       });
//   };
// };

// Update Payment
// export const postPaymentLog = (params) => {
//   return (dispatch) => {
//     return axiosInstance
//       .patch(`/crm/manual-payment/${params.uuid}/`, params)
//       .then((response) => {
//         dispatch({
//           type: POST_PAYMENT_HISTORY_SUCCESSFULLY,
//           data: response.data,
//         });
//       })
//       .catch((error) => {
//         if (error && error.response) {
//           if (error.response.status === 401 || error.response.status === 403) {
//             window.location.assign("/");
//             localStorage.clear();
//             sessionStorage.clear();
//           }
//           if (error.response) {
//             dispatch({
//               type: POST_PAYMENT_HISTORY_FAILED,
//               data: error.response.data,
//             });
//           }
//         }
//       });
//   };
// };

// export const cleanPaymentResponse = () => {
//   return (dispatch) => {
//     dispatch({ type: 'CLEAN_PAYMENT_RESPONSE' });
//   }
// }

// Delete Payment
// export const deletePaymentLog = (params) => {
//   return (dispatch) => {
//     return axiosInstance
//       .delete(`/crm/manual-payment/${params}`)
//       .then((response) => {
//         dispatch({
//           type: DELETE_PAYMENT_HISTORY_SUCCESSFULLY,
//           data: response.data,
//         });
//       })
//       .catch((error) => {
//         if (error && error.response) {
//           if (error.response.status === 401 || error.response.status === 403) {
//             window.location.assign("/");
//             localStorage.clear();
//             sessionStorage.clear();
//           }
//           if (error.response) {
//             dispatch({
//               type: DELETE_PAYMENT_HISTORY_FAILED,
//               data: error.response.data,
//             });
//           }
//         }
//       });
//   };
// };

// export const voidInvoice = (uuid) => {
//   return (dispatch) => {
//     return axiosInstance
//       .get(`/invoice/${uuid}/void_invoice/`)
//       .then((response) => {
//         dispatch({
//           type: VOID_INVOICE_SUCCESSFULLY,
//           data: response.data,
//         });
//       })
//       .catch((error) => {
//         if (error && error.response) {
//           if (error.response.status === 401 || error.response.status === 403) {
//             window.location.assign("/");
//             localStorage.clear();
//             sessionStorage.clear();
//           }
//           if (error.response) {
//             dispatch({
//               type: VOID_INVOICE_FAILED,
//               data: error.response.data,
//             });
//           }
//         }
//       });
//   };
// };

// get all service order number for invoice
export const getServiceOrderNumberList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/service-order/missing-invoice-service-order/`, { params })
      .then((response) => {
        dispatch({
          type: SERVICE_ORDER_NUMBER_LIST,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: SERVICE_ORDER_NUMBER_LIST_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// add invoice line items
export const addInvoiceLineItem = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/invoice-line-item/`, params)
      .then((response) => {
        dispatch({
          type: ADD_INVOICE_LINE_ITEM,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: ADD_INVOICE_LINE_ITEM_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// edit invoice line items
export const editInvoiceLineItem = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/invoice-line-item/${uuid}/`, params)
      .then((response) => {
        dispatch({
          type: EDIT_INVOICE_LINE_ITEM,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: EDIT_INVOICE_LINE_ITEM_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// delete invoice line items
export const deleteInvoiceLineItem = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`/invoice-line-item/${uuid}/`)
      .then((response) => {
        dispatch({
          type: DELETE_INVOICE_LINE_ITEM,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: DELETE_INVOICE_LINE_ITEM_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// Get all staff users
// export const getStaffUsers = (params) => {
//   return (dispatch) => {
//     return axiosInstance
//       .get(`/crm/staff-user/`, { params })
//       .then((response) => {
//         dispatch({
//           type: GET_STAFF_LIST_SUCCESSFULLY,
//           data: response?.data,
//         });
//       })
//       .catch((error) => {
//         if (
//           error?.response?.status === 401 ||
//           error?.response?.status === 403
//         ) {
//           window.location.assign("/");
//           localStorage.clear();
//           sessionStorage.clear();
//         }
//         if (error?.response) {
//           dispatch({
//             type: GET_STAFF_LIST_FAILED,
//             data: error?.response?.data,
//           });
//         }
//       });
//   };
// };

// add invoice line items
export const addNonServiceableEnquiry = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/non-serviceable-enquiry/`, params)
      .then((response) => {
        dispatch({
          type: ADD_NON_SERVICEABLE_ENQUIRY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: ADD_NON_SERVICEABLE_ENQUIRY_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// Get all staff users
export const getFieldTechnicianList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/ftech/field-technicians/`, { params })
      .then((response) => {
        dispatch({
          type: GET_TECHNICIAN_LIST,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_TECHNICIAN_LIST_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// Get all staff users
export const getServiceHistory = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/ftech/service-history/`, { params })
      .then((response) => {
        dispatch({
          type: GET_SERVICE_HISTORY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_SERVICE_HISTORY_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// delete phone number
export const deletePhoneNumber = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`/phone-api/${uuid}/`)
      .then((response) => {
        dispatch({
          type: DELETE_PHONE_NUMBER,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: DELETE_PHONE_NUMBER_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// Refund payment
export const refundPayment = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/crm/refund/`, params)
      .then((response) => {
        dispatch({
          type: REFUND_PAYMENT,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: REFUND_PAYMENT_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// export const remainingCreditBalance = (params) => {
//   return (dispatch) => {
//     return axiosInstance
//       .get(`/crm/refund/get-remaining-credit-balance/`, {params})
//       .then((response) => {
//         dispatch({
//           type: REFUND_REMAINING_BALANCE_SUCCESS,
//           data: response.data,
//         });
//       })
//       .catch((error) => {
//         if (error.response) {
//           if (error.response.status === 401 || error.response.status === 403) {
//             window.location.assign("/");
//             localStorage.clear();
//             sessionStorage.clear();
//           }
//           dispatch({
//             type: REFUND_REMAINING_BALANCE_FAILED,
//             data: error.response.data,
//           });
//         }
//       });
//   };
// };

//  get sales tax
export const getSalesTax = (params) => {
  return (dispatch) => {
    if(params.amount && params.amount > 0)
    {
      return axiosInstance
        .post(`/invoice-line-item/get-tax-amount/`, params)
        .then((response) => {
          dispatch({
            type: GET_SALES_TAX,
            data: response?.data,
          });
        })
        .catch((error) => {
          if (
            error?.response?.status === 401 ||
            error?.response?.status === 403
          ) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error?.response) {
            dispatch({
              type: GET_SALES_TAX_FAILED,
              data: error?.response?.data,
            });
          }
        });
    }
    else
    {
      return 0;
    }
  };
};

//Suspend Account
export const suspendAccount = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`invoice/suspend_unsuspend_customer/`, { params })
      .then((response) => {
        dispatch({
          type: SUSPEND_ACCOUNT,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: SUSPEND_ACCOUNT_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

/**
 * AUTHOR: Ritesh Solanki
 * Change Date : 09/28/2021 (Tuesday)
 * New Redesign Changes 
 */

/**
 * AUTHOR: Ritesh Solanki
 * Get Service Order
 * Called in Residential Detail Work Order > Service Order Dropdown
 * @param {*} params 
 */
export const getServiceOrderFilter = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`service-ftech/get_service_order/`, { params })
      .then((response) => {
        dispatch({
          type: GET_SERVICE_ORDER_FILTER,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_ORDER_FILTER_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

/**
 * AUTHOR: Ritesh Solanki
 * Get Work Order
 * Called in Residential Detail Work Order > Work Order Dropdown
 * @param {*} params 
 */
export const getWorkOrderFilter = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`service-ftech/get_work_order/`, { params })
      .then((response) => {
        dispatch({
          type: GET_WORK_ORDER_FILTER,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_WORK_ORDER_FILTER_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

/**
 * AUTHOR: Ritesh Solanki
 * Get Field Technician
 * Called in Residential Detail Work Order > Field Technician Dropdown
 * @param {*} params 
 */
export const getFieldTechnicianFilter = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`ftech/field-technicians/`, { params })
      .then((response) => {
        dispatch({
          type: GET_FIELD_TECHNICIAN_FILTER,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_FIELD_TECHNICIAN_FILTER_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

/**
 * AUTHOR: Ritesh Solanki
 * Get Work Orders
 * Called in Residential Detail Work Order > Work Orders
 * @param {*} params 
 */
export const getWorkOrderList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`service-ftech/`,{params})
      .then((response) => {
        dispatch({
          type: GET_WORK_ORDER_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_WORK_ORDER_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

export const getWorkOrderDetail = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`service-ftech/${params}`)
      .then((response) => {
        dispatch({
          type: GET_WORK_ORDER_DETAIL,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_WORK_ORDER_DETAIL_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

export const deactivateServiceOrder = (id, params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`service-order/${id}/`, params)
      .then((response) => {
        dispatch({
          type: DEACTIVATE_SERVICE_ORDER,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DEACTIVATE_SERVICE_ORDER_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

/**
 * AUTHOR: Ritesh Solanki
 * <DP-3487>Log a Call - Redesign</DP-3487>
 * @param {*} params 
 */
export const getRepresentativeList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`crm/call-log/representatives/`, { params })
      .then((response) => {
        dispatch({
          type: GET_REPRESENTATIVES_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_REPRESENTATIVES_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

export const validateCoupon = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/validate-coupon`, params, {})
      .then((response) => {
        dispatch({
          type: VALIDATE_COUPON_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: VALIDATE_COUPON_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

export const updateCallLog = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`crm/call-log/${uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_CALL_LOG,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_CALL_LOG_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

export const getCreditMemoDetails = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/credit-memo/get_credit_memo_details/`, { params })
      .then((response) => {
        dispatch({
          type: GET_CREDIT_MEMO_DETAIL,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_CREDIT_MEMO_DETAIL_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

// add Credit Memo
export const addCreditMemo = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/credit-memo/credit_memo_group/`, params)
      .then((response) => {
        dispatch({
          type: ADD_CREDIT_MEMO,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: ADD_CREDIT_MEMO_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// Last Three Credit Memo
export const lastThreeCreditMemo = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/credit-memo/`, {params})
      .then((response) => {
        dispatch({
          type: LAST_THREE_CREDIT_MEMO,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: LAST_THREE_CREDIT_MEMO_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// Add Credit Memo Line Item
export const addCreditMemoLineItem = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/credit-memo-line-item/`, params)
      .then((response) => {
        dispatch({
          type: ADD_CREDIT_MEMO_LINE_ITEM,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: ADD_CREDIT_MEMO_LINE_ITEM_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// Register Stax Payment Info
export const addStaxPaymentInfo = (params) => {
  // return (dispatch) => {
  //   dispatch({
  //     type: ADD_STAX_PAYMENT_INFO,
  //     data: params,
  //   });
  // }

  return (dispatch) => {
    return axiosInstance
      .post(`/user-billing-info/add_cc_from_stax/`, params)
      .then((response) => {
        dispatch({
          type: ADD_STAX_PAYMENT_INFO,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: ADD_STAX_PAYMENT_INFO_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};